import { render, staticRenderFns } from "./CandidateCard.vue?vue&type=template&id=08846fd6&scoped=true&"
import script from "./CandidateCard.vue?vue&type=script&lang=ts&"
export * from "./CandidateCard.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateCard.vue?vue&type=style&index=0&id=08846fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08846fd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VIcon,VImg})
